<script setup lang="ts">
const model = defineModel<string>({ required: true })
const props = defineProps<{ label: string; canEdit?: boolean }>()
</script>

<template>
	<div class="mb-3">
		<div class="d-flex align-items-center mb-2">
			<strong>{{ props.label }}</strong>
		</div>

		<div class="ms-3 mt-2">
			<div v-if="!props.canEdit" class="d-flex">
				<template v-if="!model">
					<div>-</div>
				</template>
				<template v-else>
					<i class="bi bi-chat-right-text text-primary"></i>
					<div class="d-flex">
						<div class="border-start border-2 border-secondary opacity-25 me-2 ms-2"></div>
						<div data-test="method-comment-input" class="text-break small">{{ model || '-' }}</div>
					</div>
				</template>
			</div>
			<textarea v-else class="form-control mt-1" maxlength="500" v-model="model" :placeholder="$t('misc.addComment')" />
		</div>
	</div>
</template>
